var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8313_119564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.683 5.241a.825.825 0 0 0-1.158 0l-8.2 8.2-3.1-3.1a.825.825 0 0 0-1.158 0 .8.8 0 0 0-.242.575c0 .217.083.425.242.575l3.675 3.675a.82.82 0 0 0 .575.242.82.82 0 0 0 .575-.242l8.791-8.775a.825.825 0 0 0 0-1.158z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8313_119564"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.833 5h14.092v10.408H3.833z"
  })))));
};
export default SvgCheck;